import type { Form } from '@adornis/forms/form.js';
import { html } from 'lit';
import { Gender, Religion } from '../../../db/enums/misc-enums.js';
import type { RegisterStudentData } from '../api/registerStudentWithSuSForm.js';
import { countryOptions, RegistrationField, yesNo } from './fields/registration-field.js';
import { SgSusEntryFormAddressFields } from './sg-sus-entry-form-address-fields.js';

export const SgSusEntryFormStudentFields = (props: { form: Form<RegisterStudentData> }) => {
  const field = (name: string, options: Parameters<typeof RegistrationField>[2]) =>
    RegistrationField(props.form, [name], options);
  return html`<div class="flex min-w-0 flex-col gap-5">
    <h2 class="font-semibold md:text-lg">Persönliche Daten des Kindes</h2>
    <div class="grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-2">
      ${field('firstName', { label: 'Vorname', required: true, autocomplete: 'section-child given-name' })}
      ${field('lastName', { label: 'Nachname', required: true, autocomplete: 'section-child family-name' })}
      ${field('geschlecht', { label: 'Geschlecht', required: true, options: Object.values(Gender) })}
      ${field('birthday', { label: 'Geburtsdatum', type: 'date', required: true, autocomplete: 'section-child bday' })}
      ${field('placeofBirth', { label: 'Geburtsort', required: true })}
      ${field('countryOfBirth', { label: 'Geburtsland', required: true, options: countryOptions })}
      ${field('religion', { label: 'Religion', required: true, options: Object.values(Religion) })}
      ${field('hasSiblingsAtMartinusSchools', { label: 'Geschwister an einer Schule der Schulgesellschaft', required: true, options: yesNo })}
      ${field('staatsangehoerigkeit', { label: 'Staat der Staatsangehörigkeit', required: true, options: countryOptions })}
      ${field('staatsangehoerigkeit2', { label: 'Weitere Staatsangehörigkeit', options: countryOptions })}
      ${field('familyLanguageIsGerman', {
        label: 'Zu Hause gesprochene Sprache',
        required: true,
        options: [
          { value: true, label: 'Deutsch' },
          { value: false, label: 'Andere Sprache' },
        ],
      })}
    </div>
    <h3 class="font-semibold">Adresse des Kindes</h3>
    ${SgSusEntryFormAddressFields({ form: props.form })}
  </div>`;
};
